import { store } from '@/Root';
import { authOperations } from '@/state/ducks/auth';
import { AxiosError } from 'axios';

const responseErrorInterceptor = async (error: AxiosError) => {
  if (error.response?.status === 401) {
    await store.dispatch(authOperations.handleLogout());
    return (window.location.href = `${window.location.origin}/login?redirect=${window.location.pathname}`);
  }

  return Promise.reject(error);
};

export default responseErrorInterceptor;
